const data = function () {
    return {
        goodslist: [],
        yue: '',
        huilv: ''
    }
};
const computed = {

}
const methods = {

    buynow(id, money, yue, true_price, huilv) {

        this.$router.push({
            path: '/paymoney',
            query: {
                id,
                money,
                yue,
                true_price,
                huilv
            }
        })

    }
}



export default {
    data,
    computed,
    methods,
}